"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalBody = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
function ModalBody(props) {
    var children = props.children, style = props.style, rest = __rest(props, ["children", "style"]);
    var _a = styles_1.useStyles(function () { return ({
        body: {
            padding: '2.5rem',
        },
    }); }), classes = _a.classes, css = _a.css;
    return (react_1.default.createElement("div", __assign({ className: css(classes.body, style) }, rest), children));
}
exports.ModalBody = ModalBody;
//# sourceMappingURL=ModalBody.js.map